// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2CF_U","title":"ClientInsurance_title__2-VIb","itemText":"ClientInsurance_itemText__1F-2L"};